import React from 'react';

export default class PilesContainer {
    constructor(gameCtx) {
        this.gameCtx = gameCtx;
    }

    setGeneralDimensions = () => {
        let myPlayer = this.gameCtx.entitiesRepo.getMyPlayer()
        this.sWidth = myPlayer.sWidth
        this.sHeight = myPlayer.sHeight
        this.cardsWidth = myPlayer.getCardsWidth()
        this.cardsHeight = myPlayer.getCardsHeight()
        this.setDimensions()
        this.setPosition()
    }

    setDimensions = () => {
        this.width = 0.6 * (this.sWidth - (2 * this.cardsHeight + 15))
        this.height = 0.5 * (this.sHeight - (2 * this.cardsHeight + 30))
    }

    setPosition = () => {
        this.left = (this.sWidth - this.width) / 2
        this.top = (this.sHeight - this.height) / 2
    }

    addPilesContainerElement = () => {
        let style = {
            position: 'absolute',
            left: `${this.left}px`,
            top: `${this.top}px`,
            width: `${this.width}px`,
            height: `${this.height}px`,
            border: '1px solid black'
        }

        const pilesContainerElement =
            <div key={20} className="piles-container-parent">
                <div style={style}></div>
            </div>
        this.gameCtx.elementsHandler.addElement(20, pilesContainerElement)
    }

    getNewPilePositions = () => {
        let left = this.left
        let top = this.top
        return [left, top]
    }

    getCandyPilePositions = () => {
        let left = this.left + this.width - this.cardsWidth
        let top = this.top
        return [left, top]
    }

    getUsedPilePositions = () => {
        let left = this.left + (this.width - this.cardsWidth) / 2
        let top = this.top + this.height - this.cardsHeight
        return [left, top]
    }
}